import styled from "styled-components";
import PhaseSixIcon from "../../../../../../../basic/phaseSixIcon/PhaseSixIcon";
import DesignConstants from "../../../../../../../constants/DesignConstants";

export const Wrapper = styled.div`
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    flex: 1;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        display: flex;
        flex-direction: column;
        gap: ${DesignConstants.SPACES.S};
    }
`;

export const WordAndScoreWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${DesignConstants.SPACES.M};

    &:first-child .word-row {
        border-top-left-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        border-top-right-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    }

    &:last-child .word-row {
        border-bottom: none;
        border-bottom-left-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        border-bottom-right-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    }
`;

export const MobileGapCardBody = styled.div`
    display: flex;
    align-items: center;
    padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.M};
    font-size: ${DesignConstants.FONT_SIZES.M};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    color: ${DesignConstants.COLORS.DARK_GREY};
`;

export const ListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${DesignConstants.SPACES.XS};
    padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.M};
    border-bottom: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    font-size: ${DesignConstants.FONT_SIZES.M};
    background-color: ${DesignConstants.COLORS.WHITE};
    flex: 1;

    &:last-child {
        border-bottom: none;
    }
`;

export const TextWrapper = styled.span`
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
`;

export const RemoveWord = styled.button`
    width: ${DesignConstants.SPACES.M};
    height: ${DesignConstants.SPACES.M};
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    color: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &.disabled {
        opacity: ${DesignConstants.OPACITY.HALF};
        cursor: not-allowed;
    }
`;

export const RemoveWordIcon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XL};
`;
